const $ = jQuery.noConflict();

/* ---------------------------------------------
   FILTER DROPDOWN UI CONTROL
----------------------------------------------*/
$(document).ready(function() {
    const $filterWrap = $('.case-study-ajax-filter .lg-filter');
    if (!$filterWrap.length) {return;}

    const $filterCols = $('.lg-filter-col');
    const $filterMenus = $('.lg-filter-menu');

    $('.lg-filter-col .lg-filter-item').on('click', function() {
        const $parentCol = $(this).parent();

        // Close others
        $filterCols.not($parentCol).removeClass('active');
        $filterMenus.not($(this).next()).stop().slideUp();

        // Toggle current
        if ($parentCol.hasClass('active')) {
            $(this).next('.lg-filter-menu').stop().slideUp();
            $parentCol.removeClass('active');
        } else {
            $(this).next('.lg-filter-menu').stop().slideDown();
            $parentCol.addClass('active');
        }
    });

    $('.lg-search').on('click', function() {
        $filterCols.removeClass('active');
        $filterMenus.stop().slideUp();
    });

    $(document).on('click touchstart', function(e) {
        if (!$(e.target).closest('.lg-filter-col, .lg-search').length) {
            $filterCols.removeClass('active');
            $filterMenus.stop().slideUp();
        }
    });

    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $filterCols.removeClass('active');
            $filterMenus.stop().slideUp();
        }
    });
});

/* ---------------------------------------------
   PREPARE FILTER DATA (REUSABLE)
----------------------------------------------*/
function prepare_filter_data() {
    const $form = $('.case-study-ajax-filter form.listing-filter-form');

    return {
        pager: $form.find('#pager').val(),
        posts_per_page: $form.find('[name="posts_per_page"]').val(),
        search_keyword: $form.find('[name="search_text"]').val(),
        sort_value: $form.find('.filter-order').val(),

        capability: $form.find('input[name="capability"]:checked').map(function() { return this.value; }).get().join(','),
        product: $form.find('input[name="product"]:checked').map(function() { return this.value; }).get().join(','),
        type: $form.find('input[name="type"]:checked').map(function() { return this.value; }).get().join(','),

        lg_capability_select: $form.find('[name="lg_capability_select"]').val(),
        lg_product_select: $form.find('[name="lg_product_select"]').val(),
        lg_type_select: $form.find('[name="lg_type_select"]').val(),
    };
}

/* ---------------------------------------------
   SUBMIT EVENT — SINGLE CLEAN HANDLER
----------------------------------------------*/
$('.case-study-ajax-filter form.listing-filter-form').on('submit', function(event) {
    event.preventDefault();

    render_selected_filters_post();

    const data = prepare_filter_data();

    post_filter_data(
        data.pager,
        data.posts_per_page,
        data.search_keyword,
        data.sort_value,
        data.capability,
        data.lg_capability_select,
        data.product,
        data.lg_product_select,
        data.type,
        data.lg_type_select,
    );
});

/* ---------------------------------------------
   AUTO RUN AJAX ON PAGE LOAD (ONE-TIME)
----------------------------------------------*/
$(window).on('load', function() {
    const data = prepare_filter_data();
    post_filter_data(
        data.pager,
        data.posts_per_page,
        data.search_keyword,
        data.sort_value,
        data.capability,
        data.lg_capability_select,
        data.product,
        data.lg_product_select,
        data.type,
        data.lg_type_select,
    );
});

/* ---------------------------------------------
   SEARCH INPUT
----------------------------------------------*/
$(document).on('change keydown', '.case-study-ajax-filter .search-text', function() {
    $('.case-study-ajax-filter #pager').val(1);
});

$(document).on('click', '.case-study-ajax-filter .icon-search-2', function(e) {
    e.preventDefault();
    $('.case-study-ajax-filter #pager').val(1);
    $('.case-study-ajax-filter form.listing-filter-form').submit();
});

/* ---------------------------------------------
   REMOVE SELECTED FILTER TAG
----------------------------------------------*/
$(document).on('click', '.case-study-ajax-filter .lg-filter-selected-list .lg-selected', function() {
    const fid = $(this).data('slug');
    $('#' + fid).prop('checked', false);
    $(this).remove();
    $('.case-study-ajax-filter #pager').val(1);
    $('.case-study-ajax-filter form.listing-filter-form').submit();
});

/* ---------------------------------------------
   PAGINATION
----------------------------------------------*/
$(document).on('click', '.case-study-ajax-filter .pagination a.next', function(e) {
    e.preventDefault();
    const pager = Number($('.case-study-ajax-filter input[name="pager"]').val());
    $('#pager').val(pager + 1);
    $('.case-study-ajax-filter form.listing-filter-form').submit();
});

$(document).on('click', '.case-study-ajax-filter .pagination a.prev', function(e) {
    e.preventDefault();
    const pager = Number($('.case-study-ajax-filter input[name="pager"]').val());
    $('#pager').val(pager - 1);
    $('.case-study-ajax-filter form.listing-filter-form').submit();
});

/* ---------------------------------------------
   RESET FILTER
----------------------------------------------*/
$('.case-study-ajax-filter .reset-filter').on('click', function(e) {
    e.preventDefault();
    const $form = $('.case-study-ajax-filter form.listing-filter-form');

    $form.find('#pager').val(1);
    $form.find('[name="search_text"]').val('');
    $form.find('select[name="filter_order"] option:first').prop('selected', true);
    $form.find('input[type="checkbox"]').prop('checked', false);

    $form.submit();
});

/* ---------------------------------------------
   CATEGORY FILTER
----------------------------------------------*/
$('.case-study-ajax-filter .filter-order, .case-study-ajax-filter .cat-filter').on('change', function() {
    $('#pager').val(1);
    $('.case-study-ajax-filter form.listing-filter-form').submit();
});

$('.case-study-ajax-filter .lg-filter-apply').on('click', function() {
    $('#pager').val(1);
    $('.case-study-ajax-filter form.listing-filter-form').submit();
});

/* ---------------------------------------------
   AJAX FUNCTION
----------------------------------------------*/
function post_filter_data(
    pager, posts_per_page, search_keyword, sort_value,
    capability, lg_capability_select, product, lg_product_select, type, lg_type_select,
) {

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: filter_obj.ajax_url,
        data: {
            action: 'fetch_case_study_list',
            security: filter_obj.nonce,
            pager, posts_per_page, search_keyword,
            product, lg_product_select,
            capability, lg_capability_select,
            type, lg_type_select,
            sort_value,
        },

        beforeSend: function() {
            $('.case-study-ajax-filter .filter-load-more').show();
            $('.case-study-ajax-filter .pagination').html('');
            $('.case-study-ajax-filter .lg-grid-main-row').html('');
        },

        success: function(response) {
            $('.case-study-ajax-filter .filter-load-more').hide();
            $('.case-study-ajax-filter .lg-grid-main-row').html(response.data).fadeIn(150);

            $('.case-study-ajax-filter .pagination').html(response.pagination).show();

            if (response.showing) {
                $('.showing-result').text(response.showing);
            }

            const initslide = Number($('#initslide').val());
            if (initslide === 1) {
                $('html, body').animate({ scrollTop: $('.case-study-ajax-filter').offset().top - 60 }, 800);
            }
            $('#initslide').val(1);

            if (response.total_pages) {
                $('input[name="max_pages"]').val(response.total_pages);
            }

            if (response.pager) {
                $('#pager').val(response.pager);
            }
        },

        error: function(error) {
            console.error('AJAX error:', error);
        },
    });
}

function render_selected_filters_post() {
    const $form = $('.case-study-ajax-filter form.listing-filter-form');
    const $list = $('.case-study-ajax-filter .lg-filter-selected-list');

    $list.empty(); // reset first

    const groups = [
        { name: 'capability', class: 'capability-selected' },
        { name: 'product', class: 'product-selected' },
        { name: 'type', class: 'type-selected' },
    ];

    groups.forEach(group => {
        $form.find(`input[name="${group.name}"]:checked`).each(function() {
            const val = $(this).val();
            const label = $(this).closest('li').find('label').data('label');

            $list.append(`
                <button class="lg-selected ${group.class} no-btn" 
                        data-slug="${group.name}_${val}">
                    <em class="close-icon"></em>${label}
                </button>
            `);
        });
    });
}
